exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "::-webkit-scrollbar {\n  width: 12px;\n  /* for vertical scrollbars */\n  height: 12px;\n  /* for horizontal scrollbars */ }\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.1); }\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.5); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/route-detail/components/route-info/route-info.component.scss
// module id = 1307
// module chunks = 0